import styled from "styled-components";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const IngresoFormButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || "1200px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const IngresoFormButtonsLeft = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-start;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const IngresoFormButtonsRight = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const DetalleDetailRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const DetalleDetailRowLabel = styled.span`
  font-size: 12px;
  color: #888;
  font-weight: bold;
  text-transform: uppercase;
`;

export const DetalleDetailRowValue = styled.span`
  font-size: 15px;
  color: #333;
  margin-top: 4px;
`;

export const DetalleModalContent = styled.div`
  text-align: left;
  padding: 10px;
  max-height: 80vh;
  overflow-y: auto;
`;

export const DetalleModalHeader = styled.div`
  text-align: left;
  padding: 10px 10px 0 10px;
`;

export const DetalleModalTitle = styled.h2`
  border-bottom: 2px solid ${({ color }) => color};
  padding-bottom: 10px;
  margin: 0 0 20px 0;
  color: ${({ color }) => color};
`;

export const DetalleGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const DetalleSectionContainer = styled.div`
  margin-bottom: 30px;
`;

export const DetalleSectionTitle = styled.h4`
  color: #444;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
`;

export const DetalleSectionParagraph = styled.p`
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
  margin: 0;
  font-size: 15px;
  border: 1px solid #eef0f2;
`;

export const DetalleSubTitle = styled.h3`
  border-bottom: 1px solid #eef0f2;
  padding-bottom: 8px;
  color: ${({ color }) => color};
`;

export const DetalleFlexColumnGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DetalleAdjuntoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
`;

export const DetalleAdjuntoTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetalleAdjuntoNombre = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: #444;
`;

export const DetalleAdjuntoMeta = styled.span`
  font-size: 12px;
  color: #888;
`;

export const DetalleDownloadButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ color }) => color};
  outline: none;
  
  .anticon {
    font-size: 20px;
  }
`;

export const DetalleEmptyText = styled.p`
  color: #888;
  font-size: 14px;
  font-style: italic;
`;

export const DetalleHistorialSection = styled.div`
  margin-bottom: 20px;
`;

export const DetalleHistorialItem = styled.div`
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid ${({ borderColor }) => borderColor};
  border-top: 1px solid #eef0f2;
  border-right: 1px solid #eef0f2;
  border-bottom: 1px solid #eef0f2;
`;

export const DetalleHistorialHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
`;

export const DetalleHistorialAutor = styled.span`
  font-weight: bold;
  font-size: 13px;
  color: #444;
`;

export const DetalleHistorialFecha = styled.span`
  font-size: 11px;
  color: #888;
`;

export const DetalleHistorialCuerpo = styled.p`
  font-size: 14px;
  color: #555;
  margin: 0;
  white-space: pre-wrap;
`;